/** Whitelisted Google accounts (client-side guard; enforced in Firestore rules too) */
export const ALLOWED_EMAILS = [
  'arunmailer@gmail.com',
  'shobs.shobana@gmail.com',
];

export const USERS = {
  ARUNKUMAR: { name: 'Arunkumar', email: 'arunmailer@gmail.com' },
  SHOBANA:   { name: 'Shobana',   email: 'shobs.shobana@gmail.com' },
};

/** Map email → display name (returns email as fallback) */
export const EMAIL_TO_NAME = Object.fromEntries(
  Object.values(USERS).map(u => [u.email, u.name])
);

export function getDisplayName(email) {
  return EMAIL_TO_NAME[email] ?? email ?? 'Unknown';
}

/** Default expense categories (from spec Meta Data sheet) */
export const DEFAULT_CATEGORIES = [
  { id: 'aquarium',        label: 'Aquarium',          emoji: '🐠', color: '#0288D1' },
  { id: 'development',     label: 'Development',        emoji: '💻', color: '#5E35B1' },
  { id: 'dress_grooming',  label: 'Dress & Grooming',   emoji: '👗', color: '#EC407A' },
  { id: 'eats_chats',      label: 'Eats & Chats',       emoji: '☕', color: '#8D6E63' },
  { id: 'entertainment',   label: 'Entertainment',      emoji: '🎬', color: '#EF6C00' },
  { id: 'fuel',            label: 'Fuel',               emoji: '⛽', color: '#FF7043' },
  { id: 'gifts',           label: 'Gifts',              emoji: '🎁', color: '#F06292' },
  { id: 'grocery',         label: 'Grocery',            emoji: '🛒', color: '#1565C0' },
  { id: 'household',       label: 'Household Items',    emoji: '🏠', color: '#546E7A' },
  { id: 'lodging',         label: 'Lodging',            emoji: '🏨', color: '#00838F' },
  { id: 'meals',           label: 'Meals',              emoji: '🍽', color: '#00695C' },
  { id: 'medical',         label: 'Medical',            emoji: '💊', color: '#D32F2F' },
  { id: 'others',          label: 'Others',             emoji: '🔖', color: '#78909C' },
  { id: 'rentals',         label: 'Rentals',            emoji: '🏠', color: '#2E7D32' },
  { id: 'repairs',         label: 'Repairs',            emoji: '🔧', color: '#6D4C41' },
  { id: 'school',          label: 'School Expenses',    emoji: '🎓', color: '#E65100' },
  { id: 'toys',            label: 'Toys',               emoji: '🧸', color: '#FFA726' },
  { id: 'transportation',  label: 'Transportation',     emoji: '🚗', color: '#6A1B9A' },
  { id: 'travel',          label: 'Travel',             emoji: '✈️', color: '#00695C' },
];

/** Default payment modes */
export const DEFAULT_PAYMENT_MODES = [
  { id: 'cash',  label: 'Cash',  color: '#4CAF50' },
  { id: 'hdfc',  label: 'HDFC',  color: '#1565C0' },
  { id: 'rupay', label: 'Rupay', color: '#E65100' },
  { id: 'icici', label: 'ICICI', color: '#B71C1C' },
  { id: 'citi',  label: 'Citi',  color: '#6A1B9A' },
];

/** Planned expense labels */
export const PLANNED_LABELS = [
  { id: 'travel',      label: '✈ Travel' },
  { id: 'school_fees', label: '🎓 School Fees' },
  { id: 'big_purchase',label: '🛍 Big Purchase' },
  { id: 'medical',     label: '🏥 Medical' },
  { id: 'other',       label: '🔖 Other' },
];

/** Budget alert thresholds */
export const BUDGET_THRESHOLDS = {
  WARNING: 0.80,
  DANGER:  1.00,
};

/** Traffic-light colour helpers */
export function getBudgetStatus(spent, budget) {
  if (!budget || budget === 0) return 'none';
  const ratio = spent / budget;
  if (ratio >= BUDGET_THRESHOLDS.DANGER)  return 'danger';
  if (ratio >= BUDGET_THRESHOLDS.WARNING) return 'warning';
  return 'ok';
}

export function getBudgetColor(status) {
  switch (status) {
    case 'danger':  return '#B71C1C';
    case 'warning': return '#F57F17';
    case 'ok':      return '#2E7D32';
    default:        return '#9E9E9E';
  }
}
